/*
  assets/ws-store-locator.js  ("Find us at Target" store finder)
  LAST UPDATED: 2026-10-08 PST. New Target store list. A card now shows the status tag, the street line and the phone only when the store has them; "Get directions" searches "Target <name> <ZIP>" when there is no street; a search keeps the other parts of the page address (setQuery).
  2026-10-07 PST. NaN guard (code review M9): a city or state search averages only stores that have la and lo, and a store with no position sorts last. Earlier today: redesign, map-first page. Removed the state grid, state select, filter chips and the full list; only the 4 nearest cards show after a search. Pairs with sections/ws-store-locator.liquid and assets/ws-stores.css.
  What it does: fetches ONE stores JSON after first paint, then lists the nearest stores for a ZIP code, a city, or the visitor's location.
  Privacy: the visitor's location is read in the browser and used only for the distance sums. Nothing is sent anywhere.
  Safety: every piece of data is written with textContent or setAttribute, never innerHTML.
  Data shape: {"v":1,"retailer":"target","asOf":"2026-10-07","stores":[{"id","n","a","c","s","z","zz"?,"p","t","la","lo"}]}
  ZIP centroids (assets/ws-data-zips.json, {"30307":[lat,lon]}) are fetched only on the first ZIP search.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-ws-stores]');
  if (!root) return;

  var NAMES = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' };
  var PAGE = 4; /* the redesign shows only the nearest few stores as compact cards (2026-10-07 PST) */

  var q = function (s) { return root.querySelector(s); };
  var form = q('[data-wsl-form]'), input = q('#wsl-q');
  var live = q('[data-wsl-live]'), lead = q('[data-wsl-lead]'), hintEl = q('[data-wsl-hint]');
  var resultsBox = q('[data-wsl-results]'), listEl = q('[data-wsl-list]');
  var resetBtn = q('[data-wsl-reset]'), geoBtn = q('[data-wsl-geo]');
  var labels = { tags: {} };
  try { labels = JSON.parse(root.getAttribute('data-labels')) || labels; } catch (e) { /* keep defaults */ }
  var directions = root.getAttribute('data-directions') !== 'false';

  var stores = null, asOf = '', zips = null, zipsPromise = null;
  var st = { ref: null, refText: '', status: 'all', state: '', shown: PAGE, list: [], area: null, src: '' };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function say(msg, isError) {
    live.textContent = msg;
    live.classList.toggle('is-error', !!isError);
  }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  /* ---------- data ---------- */
  function load() {
    say('Loading stores...');
    // a live feed may fail (offline, 404, bad shape): then the theme file in data-fallback is used (2026-10-08 PST)
    var get = function (u) {
      return fetch(u, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { if (!d || !Array.isArray(d.stores)) throw new Error('shape'); return d; });
    };
    var url = root.getAttribute('data-json'), fb = root.getAttribute('data-fallback');
    get(url).catch(function (e) { if (fb && fb !== url) return get(fb); throw e; })
      .then(function (d) {
        stores = d.stores;
        asOf = d.asOf || '';
        stores.forEach(function (s) { s.k = String(s.c || '').toLowerCase(); });
        setLead();
        say('');
        var p = new URLSearchParams(location.search).get('q');
        if (p) { input.value = p.slice(0, 60); search(); } else { update(); }
      })
      .catch(function () {
        say('We could not load the store list. Please try again later, or use Target\'s own store finder below.', true);
      });
  }
  function loadZips() {
    if (zips) return Promise.resolve(zips);
    if (!zipsPromise) {
      zipsPromise = fetch(root.getAttribute('data-zips'), { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (m) { zips = m; return m; })
        .catch(function (e) { zipsPromise = null; throw e; });
    }
    return zipsPromise;
  }
  function setLead() {
    var all = {};
    stores.forEach(function (s) { all[s.s] = 1; });
    var tpl = root.getAttribute('data-lead');
    if (!lead || !tpl) return;
    lead.textContent = tpl.replace('{states}', Object.keys(all).length).replace('{count}', stores.length);
  }

  /* ---------- search ---------- */
  function miles(a, b, c, d) {
    var r = Math.PI / 180, dLa = (c - a) * r, dLo = (d - b) * r;
    var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 3958.8 * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  /* Put the search in the address bar (?q=...), or take it out. Every OTHER part of the address is kept.
     Before 2026-10-08 PST this wrote only "?q=...", so a page opened with "?view=store-locator" (the theme preview) or with
     ad tracking parts lost them: a reload or a shared link then opened a different page. */
  function setQuery(text) {
    try {
      var u = new URL(location.href);
      if (text) u.searchParams.set('q', text); else u.searchParams.delete('q');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { /* not important */ }
  }
  function search() {
    if (!stores) { say('The store list is still loading. Try again in a moment.'); return; }
    var raw = input.value.trim().replace(/\s+/g, ' ');
    if (!raw) { say('Enter a ZIP code or a city and state, or use your location.', true); return; }
    st.state = '';
    setQuery(raw);
    var zip = raw.match(/^(\d{5})(?:-?\d{4})?$/);
    if (zip) {
      say('Looking up ZIP code ' + zip[1] + '...');
      loadZips().then(function (m) {
        if (!m[zip[1]]) { say('We could not find ZIP code ' + zip[1] + '. Check it and try again.', true); return; }
        setRef(m[zip[1]], 'ZIP code ' + zip[1]);
      }).catch(function () { say('We could not look up that ZIP code right now. Try a city and state instead.', true); });
      return;
    }
    var t = raw.toLowerCase().replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim(), code = '', city = t, k;
    var len = 0;
    for (k in NAMES) {
      var nm = NAMES[k].toLowerCase();
      if (nm.length > len && (t === nm || t.slice(-nm.length - 1) === ' ' + nm)) { code = k; len = nm.length; city = t.slice(0, t.length - nm.length).trim(); }
    }
    if (!code) {
      var m2 = t.match(/^(.*?)\s?\b([a-z]{2})$/);
      if (m2 && NAMES[m2[2].toUpperCase()] && (m2[1] || t.length === 2)) { code = m2[2].toUpperCase(); city = m2[1]; }
    }
    if (!city) { setState(code); return; }
    var hits = stores.filter(function (s) { return (!code || s.s === code) && s.k === city; });
    if (!hits.length) hits = stores.filter(function (s) { return (!code || s.s === code) && s.k.indexOf(city) === 0; });
    if (!hits.length) { say('We could not find stores in "' + raw + '". Try a ZIP code, or pick a state.', true); return; }
    var by = {}, best = '';
    hits.forEach(function (s) { by[s.s] = (by[s.s] || 0) + 1; if (!best || by[s.s] > by[best]) best = s.s; });
    hits = hits.filter(function (s) { return s.s === best; });
    /* Average only the stores that HAVE coordinates. A store without la and lo used to turn the sum into NaN,
       and every distance after it was NaN too (code review M9, 2026-10-07 PST). */
    var la = 0, lo = 0, placed = 0;
    hits.forEach(function (s) { if (hasPos(s)) { la += s.la; lo += s.lo; placed++; } });
    if (!placed) {
      /* none of these stores has a map position yet: show the state instead of a made-up point */
      setState(best);
      say('We found stores in ' + hits[0].c + ', ' + hits[0].s + ' but cannot place them on the map yet. Showing the whole state. Try a ZIP code.', true);
      return;
    }
    setRef([la / placed, lo / placed], hits[0].c + ', ' + hits[0].s);
  }
  /* true only for a real, finite latitude and longitude (a missing la or lo, null, "NaN" or Infinity is not a position) */
  function hasPos(s) { return typeof s.la === 'number' && isFinite(s.la) && typeof s.lo === 'number' && isFinite(s.lo); }
  function setRef(c, text, quiet) {
    if (!c || !isFinite(c[0]) || !isFinite(c[1])) { say('We could not work out where that is. Try a ZIP code instead.', true); return; }
    st.ref = c; st.refText = text; st.shown = PAGE; st.area = null;
    update();
    /* after a shopper's search, scroll just enough that the map and the nearest stores are both on screen */
    if (!quiet && resultsBox.getBoundingClientRect().bottom > window.innerHeight) {
      resultsBox.scrollIntoView({ block: 'end', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
  function setState(code) {
    st.ref = null; st.refText = '';
    st.state = code || ''; st.shown = PAGE; st.area = null;
    update();
  }
  function locate() {
    if (!navigator.geolocation) { say('Your browser cannot share a location. Enter a ZIP code instead.', true); return; }
    if (!stores) { say('The store list is still loading. Try again in a moment.'); return; }
    say('Finding your location...');
    navigator.geolocation.getCurrentPosition(function (p) {
      input.value = '';
      st.state = '';
      setRef([p.coords.latitude, p.coords.longitude], 'your location');
    }, function (err) {
      say(err && err.code === 1 ? 'Location permission was turned off, so we cannot find stores near you. Enter a ZIP code instead.' : 'We could not find your location. Enter a ZIP code instead.', true);
    }, { timeout: 10000, maximumAge: 600000 });
  }
  function reset() {
    st.ref = null; st.refText = ''; st.state = ''; st.status = 'all'; st.shown = PAGE; st.area = null;
    input.value = '';
    setQuery('');
    update();
    input.focus();
  }

  /* ---------- render ---------- */
  function update() {
    var list = stores.filter(function (s) {
      return (!st.state || s.s === st.state) && (st.status === 'all' || s.t === st.status) && (!st.area || st.area[s.id]);
    });
    var searching = !!(st.ref || st.state);
    if (st.ref) {
      /* a store with no position (or a distance that is not a number) goes LAST at 99999, never NaN */
      list.forEach(function (s) {
        var d = hasPos(s) ? miles(st.ref[0], st.ref[1], s.la, s.lo) : NaN;
        s.d = isFinite(d) ? d : 99999;
      });
      list.sort(function (a, b) { return (a.d - b.d) || a.c.localeCompare(b.c) || a.n.localeCompare(b.n); });
    } else {
      list.sort(function (a, b) { return a.c.localeCompare(b.c) || a.n.localeCompare(b.n); });
    }
    st.list = list;
    /* cards show only when there is a search point (ZIP, city, location, map area, pin); a state alone just fills the map */
    resultsBox.hidden = !st.ref;
    if (hintEl) hintEl.hidden = !!st.ref;
    listEl.textContent = '';
    if (!searching) { say(''); emit(); return; }
    renderCards(0);
    var where = st.ref ? ' near ' + st.refText : ' in ' + (NAMES[st.state] || st.state);
    if (!list.length) say('No stores match those choices' + where + '. Try another search.', true);
    else if (st.ref) say('The ' + Math.min(st.shown, list.length) + ' nearest of ' + plural(list.length, 'store', 'stores') + where + '.');
    else say(plural(list.length, 'store', 'stores') + where + '. Enter your ZIP code to see the nearest ones.');
    emit();
  }
  /* map hooks (2026-10-07 PST): assets/ws-store-map.js listens for this event and reads root.wslApi */
  function emit() {
    var src = st.src; st.src = '';
    root.dispatchEvent(new CustomEvent('wsl:update', { detail: { source: src } }));
  }
  function renderCards(from) {
    var end = Math.min(st.shown, st.list.length), first = null;
    for (var i = from; i < end; i++) {
      var li = card(st.list[i]);
      if (i === from) first = li;
      listEl.appendChild(li);
    }
    return first;
  }
  /* "City, ST 12345-6789" from the parts that exist (never the word undefined, never a stray comma) */
  function place(s) {
    var cs = [s.c, s.s].filter(Boolean).join(', ');
    return [cs, s.z ? s.z + (s.zz ? '-' + s.zz : '') : ''].filter(Boolean).join(' ');
  }
  /* What to search on Google Maps: the street address when there is one, or "Target <store name> <ZIP>" when there is not */
  function mapQuery(s) {
    return s.a ? s.a + ', ' + [s.c, s.s].filter(Boolean).join(', ') + ' ' + (s.z || '') : ['Target', s.n, s.s, s.z].filter(Boolean).join(' ');
  }
  function card(s) {
    var li = el('li', 'ws-card ws-card--sm wsl-card');
    li.tabIndex = -1;
    var top = el('div', 'wsl-card__top');
    top.appendChild(el('h3', 'wsl-card__name', s.n));
    if (st.ref && s.d < 99999) top.appendChild(el('span', 'wsl-card__dist', s.d < 1 ? 'less than 1 mile' : 'about ' + plural(Math.round(s.d), 'mile', 'miles')));
    li.appendChild(top);
    /* A store may have no pickup status, no street or no phone yet (2026-10-08 PST). Each part shows only when it has a value. */
    if (s.t) li.appendChild(el('span', 'wsl-tag wsl-tag--' + s.t, (labels.tags && labels.tags[s.t]) || s.t));
    var addr = el('p', 'wsl-card__addr');
    if (s.a) {
      addr.appendChild(document.createTextNode(s.a));
      addr.appendChild(document.createElement('br'));
    }
    addr.appendChild(document.createTextNode(place(s)));
    li.appendChild(addr);
    var links = el('p', 'wsl-card__links');
    if (s.p) {
      var tel = el('a', 'ws-link', s.p);
      tel.href = 'tel:+1' + String(s.p).replace(/\D/g, '');
      links.appendChild(tel);
    }
    if (directions) {
      var dir = el('a', 'ws-link', 'Get directions');
      dir.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(mapQuery(s));
      dir.target = '_blank';
      dir.rel = 'noopener noreferrer';
      links.appendChild(dir);
    }
    if (!s.a && s.z) {
      /* no street on file: send the shopper to Target's own store finder for this ZIP code */
      var tgt = el('a', 'ws-link', 'Store details at Target');
      tgt.href = 'https://www.target.com/store-locator/find-stores/' + encodeURIComponent(s.z);
      tgt.target = '_blank';
      tgt.rel = 'noopener noreferrer';
      links.appendChild(tgt);
    }
    if (root.querySelector('[data-wsl-map]')) {
      var onmap = el('button', 'wsl-card__map', 'Show on map');
      onmap.type = 'button';
      onmap.setAttribute('data-id', s.id);
      onmap.setAttribute('aria-label', 'Show ' + s.n + ' on the map');
      links.appendChild(onmap);
    }
    li.setAttribute('data-id', s.id);
    li.appendChild(links);
    return li;
  }

  /* ---------- events ---------- */
  form.addEventListener('submit', function (e) { e.preventDefault(); search(); });
  geoBtn.addEventListener('click', locate);
  resetBtn.addEventListener('click', reset);

  /* ---------- map hooks (2026-10-07 PST) ---------- */
  function byId(id) { for (var i = 0; i < stores.length; i++) if (stores[i].id === id) return stores[i]; return null; }
  function cardFor(id) { return listEl.querySelector('[data-id="' + String(id).replace(/[^\w-]/g, '') + '"]'); }
  function mark(li) {
    var old = listEl.querySelector('.is-active');
    if (old) old.classList.remove('is-active');
    if (li) li.classList.add('is-active');
  }
  root.wslApi = {
    stores: function () { return stores; },
    state: function () { return st; },
    miles: miles,
    /* "Search this area": list = stores in view, already sorted by distance from center (max 50) */
    area: function (ids, center) {
      input.value = ''; st.state = '';
      setQuery('');
      st.area = {}; ids.forEach(function (id) { st.area[id] = 1; });
      st.ref = center; st.refText = 'the map area'; st.shown = PAGE; st.src = 'area';
      update();
    },
    /* a pin was chosen on the map: show and highlight its card (no map move) */
    pick: function (id, noScroll) {
      var s = byId(id);
      if (!s) return;
      var i = -1;
      if (!resultsBox.hidden) st.list.forEach(function (x, n) { if (x.id === id) i = n; });
      if (i < 0 || i >= st.shown) {
        /* not one of the cards on screen: show the stores nearest to this pin instead (the map does not move) */
        st.area = null; st.state = ''; st.src = 'pin';
        setRef([s.la, s.lo], s.c + ', ' + s.s, true);
        i = -1;
        st.list.forEach(function (x, n) { if (x.id === id) i = n; });
      }
      var li = cardFor(id);
      mark(li);
      if (li && !noScroll) li.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  listEl.addEventListener('click', function (e) {
    if (e.target.closest('a')) return;
    var li = e.target.closest('li[data-id]');
    if (!li) return;
    mark(li);
    root.dispatchEvent(new CustomEvent('wsl:card', { detail: { id: li.getAttribute('data-id'), button: !!e.target.closest('.wsl-card__map') } }));
  });

  /* start after first paint */
  var started = false;
  function go() { if (!started) { started = true; load(); } }
  requestAnimationFrame(function () { setTimeout(go, 0); });
  setTimeout(go, 1500); /* background tabs pause animation frames */
})();
